import type { ToolFn, ToolSpec } from '../types';

export const highlightSpec: ToolSpec = {
  name: 'highlight',
  description:
    'Highlight elements in the 3D view by expressID. Call once, at the end, with every id the answer refers to.',
  input_schema: {
    type: 'object',
    properties: { ids: { type: 'array', items: { type: 'integer' } } },
    required: ['ids'],
  },
};

export const MAX_HIGHLIGHTS = 400;

export const highlight =
  (): ToolFn =>
  ({ ids }) => ({
    ids: (Array.isArray(ids) ? ids : [])
      .map(Number)
      .filter(Number.isFinite)
      .slice(0, MAX_HIGHLIGHTS),
  });
